import { render } from "./LichSuChiaGio.vue?vue&type=template&id=93534be2&scoped=true&ts=true"
import script from "./LichSuChiaGio.vue?vue&type=script&lang=ts"
export * from "./LichSuChiaGio.vue?vue&type=script&lang=ts"

import "./LichSuChiaGio.vue?vue&type=style&index=0&id=93534be2&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/PHCN/ChiaGioThucHien/VLTL_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93534be2"]])

export default __exports__